import React, { useState } from 'react';
import { Modal, Box } from '@mui/material';

const DialogWrapper = ({
  children,
  showOnClick
}) => {
  const [open, setOpen] = useState(false);
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Modal, {
    open: open,
    onClose: () => setOpen(prev => !prev)
  }, /*#__PURE__*/React.createElement(Box, {
    sx: {
      position: 'absolute',
      top: '50%',
      left: '50%',
      transform: 'translate(-50%, -50%)'
    },
    onClick: () => setOpen(false)
  }, showOnClick || children)), /*#__PURE__*/React.createElement(Box, {
    sx: {
      width: '100%',
      zIndex: 10000,
      '&:hover': {
        opacity: 0.9
      }
    },
    onClick: () => setOpen(true)
  }, children));
};

export { DialogWrapper };
